/* Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, {
  type AxiosInstance,
  type AxiosRequestConfig,
} from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
  /**
   * show loading status
   */
  loading?: boolean;
  /**
   * display error message
   */
  showError?: boolean;
  /**
   * indicates whether Authorization credentials are required for the request
   * @default true
   */
  withAuthorization?: boolean;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
  /** only in axios interceptor config*/
  loading: boolean;
  showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(
  configs: IRequestConfig,
  resolve: (p: any) => void,
  reject: (p: any) => void
): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(
  method: string,
  contentType: string,
  url: string,
  options: any
): IRequestConfig {
  const configs: IRequestConfig = {
    loading: serviceOptions.loading,
    showError: serviceOptions.showError,
    ...options,
    method,
    url,
  };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType,
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class OrderService {
  /**
   *
   */
  static confirmOrderPaymentCreate(
    params: {
      /** Идентификатор заказа */
      orderId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CommonSuccess> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/confirm-order-payment/{order_id}';
      url = url.replace('{order_id}', params['orderId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static failedOrderPaymentCreate(
    params: {
      /** Идентификатор заказа */
      orderId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CommonSuccess> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/failed-order-payment/{order_id}';
      url = url.replace('{order_id}', params['orderId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1OrderDetailRetrieve(
    params: {
      /** Идентификатор заказа */
      orderId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrderDetail> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/order_detail/{order_id}';
      url = url.replace('{order_id}', params['orderId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1OrdersCreate(
    params: {
      /** requestBody */
      body?: OrderCreateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayOrder> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/orders/';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1OrdersRetrieve(
    params: {
      /** Идентификатор заказа */
      orderId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Order> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/orders/{order_id}';
      url = url.replace('{order_id}', params['orderId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1OrdersConfirmCreate(
    params: {
      /** Идентификатор заказа */
      orderId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CommonSuccess> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/orders/{order_id}/confirm/';
      url = url.replace('{order_id}', params['orderId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1OrdersRepeatCreate(
    params: {
      /** requestBody */
      body?: RepeatOrderRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayOrder> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/orders/repeat/';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1OrdersUserList(
    options: IRequestOptions = {}
  ): Promise<OrderDetail[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/orders/user/';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
}

export class CallbacksService {
  /**
   *
   */
  static menuChangedCreate(
    params: {
      /** requestBody */
      body?: MenuChangeTriggerRequestRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/menu/changed';

      const configs: IRequestConfig = getConfigs(
        'post',
        'multipart/form-data',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static remoteOrderStatusCreate(
    params: {
      /** requestBody */
      body?: ChangeOrderStatusRequestRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/remote-order/status';

      const configs: IRequestConfig = getConfigs(
        'post',
        'multipart/form-data',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static stopListChangedCreate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/stop-list/changed';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
}

export class AuthService {
  /**
   *
   */
  static v1AuthGetAuthTokenCreate(
    params: {
      /** requestBody */
      body?: GetAuthTokenRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthTokenResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/auth/get-auth-token/';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1AuthGetPairTokensCreate(
    params: {
      /** requestBody */
      body?: GetPairTokensRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PairTokens> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/auth/get-pair-tokens/';

      const configs: IRequestConfig = getConfigs(
        'post',
        'multipart/form-data',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1AuthRefreshCreate(
    params: {
      /** requestBody */
      body?: RefreshTokensRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PairTokens> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/auth/refresh/';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1AuthYandexCallbackCreate(
    params: {
      /** requestBody */
      body?: CallbackInputRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PairTokens> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/auth/yandex/callback/';

      const configs: IRequestConfig = getConfigs(
        'post',
        'multipart/form-data',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1AuthYandexLoginRetrieve(
    params: {
      /** 32+ символов */
      state: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RedirectUrl> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/auth/yandex/login/{state}/';
      url = url.replace('{state}', params['state'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
}

export class CartService {
  /**
   *
   */
  static v1CartList(options: IRequestOptions = {}): Promise<CartResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/cart/';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1CartCreate(
    params: {
      /** requestBody */
      body?: CartRequestRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CartResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/cart/';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1CartDestroy(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/cart/';

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1CartPartialUpdate(
    params: {
      /** Идентификатор элемента корзины */
      itemId: number;
      /** requestBody */
      body?: PatchedCartItemEditRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CartResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/cart/{item_id}/';
      url = url.replace('{item_id}', params['itemId'] + '');

      const configs: IRequestConfig = getConfigs(
        'patch',
        'application/json',
        url,
        options
      );

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn(
        '适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body'
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1CartDestroy2(
    params: {
      /** Идентификатор элемента корзины */
      itemId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/cart/{item_id}/';
      url = url.replace('{item_id}', params['itemId'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
}

export class CompaniesService {
  /**
   *
   */
  static v1CompaniesRetrieve(
    params: {
      /** Идентификатор компании для получения информации о ней */
      companyId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Company> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/companies/{company_id}';
      url = url.replace('{company_id}', params['companyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
}

export class ProductsService {
  /**
   *
   */
  static v1ProductOptionsRetrieve(
    params: {
      /** Идентификатор опции продукта для получения информации о ней */
      productOptionId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProductOption> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/product_options/{product_option_id}/';
      url = url.replace('{product_option_id}', params['productOptionId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1ProductsRetrieve(
    params: {
      /** Идентификатор продукта для получения информации о нем */
      productId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Productdetail> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/products/{product_id}/';
      url = url.replace('{product_id}', params['productId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
}

export class RestaurantsService {
  /**
   *
   */
  static v1RestaurantsList(
    params: {
      /** Идентификатор компании для получения списка точек обслуживания */
      companyId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Restaurant[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/restaurants/';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { company_id: params['companyId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1RestaurantsRetrieve(
    params: {
      /** Идентификатор ресторана для получения информации о нем */
      restaurantId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Restaurant> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/restaurants/{restaurant_id}/';
      url = url.replace('{restaurant_id}', params['restaurantId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static v1RestaurantsMenuList(
    params: {
      /** Идентификатор ресторана для получения продуктов из всех меню */
      restaurantId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RestaurantMenu[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/restaurants/{restaurant_id}/menu/';
      url = url.replace('{restaurant_id}', params['restaurantId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
}

export class LoyaltyService {
  /**
   *
   */
  static v1UserBonusesRetrieve(
    params: {
      /** Идентификатор ресторана */
      restaurantId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserBonuses> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/user_bonuses/{restaurant_id}/';
      url = url.replace('{restaurant_id}', params['restaurantId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
}

/** AuthTokenResponse */
export interface AuthTokenResponse {
  /**  */
  token: string;
}

/** BadRequest */
export interface BadRequest {
  /**  */
  detail: string;
}

/** CallbackInputRequest */
export interface CallbackInputRequest {
  /**  */
  code: string;

  /**  */
  state: string;
}

/** CartRequestRequest */
export interface CartRequestRequest {
  /**  */
  menu: number;

  /**  */
  product: number;

  /**  */
  product_options?: any | null[];

  /**  */
  quantity: number;
}

/** CartResponse */
export interface CartResponse {
  /**  */
  id: number;

  /**  */
  is_active?: boolean;

  /**  */
  session_token: string;

  /**  */
  product_options?: any | null[];

  /**  */
  quantity: number;

  /**  */
  customer?: number;

  /**  */
  menu: number;

  /**  */
  product: number;
}

/** Category */
export interface Category {
  /**  */
  id: number;

  /**  */
  name: string;

  /**  */
  is_active?: boolean;

  /**  */
  display_name?: string;

  /**  */
  order?: number;

  /**  */
  company: number;
}

/** ChangeOrderStatusRequestRequest */
export interface ChangeOrderStatusRequestRequest {
  /**  */
  eventId: string;

  /**  */
  guid: string;

  /**  */
  status: string;

  /**  */
  statusMessage?: string;
}

/** CommonSuccess */
export interface CommonSuccess {
  /**  */
  detail: string;
}

/** Company */
export interface Company {
  /**  */
  id: number;

  /**  */
  documents: CompanyDocument[];

  /**  */
  is_active?: boolean;

  /**  */
  name: string;

  /**  */
  description?: string;

  /**  */
  contacts?: any | null;
}

/** CompanyDocument */
export interface CompanyDocument {
  /**  */
  name: string;

  /**  */
  file: string;

  /**  */
  document_type?: CombinedDocumentTypeTypes;
}

/** GetAuthTokenRequest */
export interface GetAuthTokenRequest {
  /**  */
  phone: string;
}

/** GetPairTokensRequest */
export interface GetPairTokensRequest {
  /**  */
  phone: string;

  /**  */
  auth_token: string;
}

/** MenuChangeTriggerRequestRequest */
export interface MenuChangeTriggerRequestRequest {
  /**  */
  eventId: string;

  /**  */
  type: string;
}

/** Order */
export interface Order {
  /**  */
  id: number;

  /**  */
  created_at: Date;

  /**  */
  updated_at: Date;

  /**  */
  is_active?: boolean;

  /**  */
  session_token: string;

  /**  */
  status?: CombinedStatusTypes;

  /**  */
  short_code?: string;

  /**  */
  payment_attempts?: number;

  /**  */
  total: number;

  /**  */
  external_id?: string;

  /**  */
  comment?: string;

  /**  */
  customer?: number;

  /**  */
  restaurant?: number;
}

/** OrderCreateRequest */
export interface OrderCreateRequest {
  /**  */
  restaurant_id: number;
}

/** OrderDetail */
export interface OrderDetail {
  /**  */
  id: number;

  /**  */
  items: OrderItems[];

  /**  */
  created_at: Date;

  /**  */
  updated_at: Date;

  /**  */
  is_active?: boolean;

  /**  */
  session_token: string;

  /**  */
  status?: CombinedStatusTypes;

  /**  */
  short_code?: string;

  /**  */
  payment_attempts?: number;

  /**  */
  total: number;

  /**  */
  external_id?: string;

  /**  */
  comment?: string;

  /**  */
  customer?: number;

  /**  */
  restaurant?: number;
}

/** OrderItems */
export interface OrderItems {
  /**  */
  id: number;

  /**  */
  product_options?: any | null[];

  /**  */
  quantity: number;

  /**  */
  price: number;

  /**  */
  order: number;

  /**  */
  product: number;
}

/** PairTokens */
export interface PairTokens {
  /**  */
  access_token: string;

  /**  */
  refresh_token: string;
}

/** PatchedCartItemEditRequest */
export interface PatchedCartItemEditRequest {
  /**  */
  quantity?: number;

  /**  */
  product_options?: any | null[];
}

/** PayOrder */
export interface PayOrder {
  /**  */
  order_id: number;

  /**  */
  payment_url: string;
}

/** ProductOption */
export interface ProductOption {
  /**  */
  id: number;

  /**  */
  is_active?: boolean;

  /**  */
  name: string;

  /**  */
  description?: string;

  /**  */
  kcal?: number;

  /**  */
  proteins?: number;

  /**  */
  fats?: number;

  /**  */
  carbohydrates?: number;

  /**  */
  image?: string;

  /**  */
  external_id?: string;

  /**  */
  renameable?: boolean;

  /**  */
  company: number;
}

/** Productdetail */
export interface Productdetail {
  /**  */
  id: number;

  /**  */
  category: CombinedCategoryTypes;

  /**  */
  is_active?: boolean;

  /**  */
  name: string;

  /**  */
  parameter?: string;

  /**  */
  description?: string;

  /**  */
  composition?: string;

  /**  */
  kcal?: number;

  /**  */
  proteins?: number;

  /**  */
  fats?: number;

  /**  */
  carbohydrates?: number;

  /**  */
  image?: string;

  /**  */
  external_id?: string;

  /**  */
  parameter_external_id?: string;

  /**  */
  company: number;
}

/** RedirectUrl */
export interface RedirectUrl {
  /**  */
  redirect_url: string;
}

/** RefreshTokensRequest */
export interface RefreshTokensRequest {
  /**  */
  phone: string;

  /**  */
  refresh_token: string;
}

/** RepeatOrderRequest */
export interface RepeatOrderRequest {
  /**  */
  order_id: number;
}

/** Restaurant */
export interface Restaurant {
  /**  */
  id: number;

  /**  */
  company_description?: string;

  /**  */
  images: RestaurantImage[];

  /**  */
  is_active?: boolean;

  /**  */
  name: string;

  /**  */
  description?: string;

  /**  */
  address: string;

  /** Координаты (широта, долгота) */
  coordinates: number[];

  /**  */
  phone?: string;

  /**  */
  email?: string;

  /**  */
  working_time: any | null;

  /**  */
  image?: string;

  /**  */
  external_id?: string;

  /**  */
  company: number;
}

/** RestaurantImage */
export interface RestaurantImage {
  /**  */
  image?: string;

  /**  */
  title?: string;
}

/** RestaurantMenu */
export interface RestaurantMenu {
  /**  */
  menu_id: number;

  /**  */
  name: string;

  /**  */
  open_at: string;

  /**  */
  close_at: string;

  /**  */
  items: RestaurantMenuItem[];
}

/** RestaurantMenuItem */
export interface RestaurantMenuItem {
  /**  */
  menu_item_id: number;

  /**  */
  product_id: number;

  /**  */
  name: string;

  /**  */
  category?: CombinedCategoryTypes;

  /**  */
  description?: string;

  /**  */
  composition: string;

  /**  */
  kcal: number;

  /**  */
  proteins: number;

  /**  */
  fats: number;

  /**  */
  carbohydrates: number;

  /**  */
  parameter: string;

  /**  */
  image?: string;

  /**  */
  price: number;

  /**  */
  options: ProductOption[];

  /**  */
  menu_items_variants?: number[];
}

/** UserBonuses */
export interface UserBonuses {
  /**  */
  bonuses: number;
}
export type CombinedDocumentTypeTypes = DocumentTypeEnum;
export enum DocumentTypeEnum {
  'offer' = 'offer',
  'agreement' = 'agreement',
}
export type CombinedStatusTypes = StatusEnum;
export type CombinedCategoryTypes = Category;
export enum StatusEnum {
  'CREATED' = 'CREATED',
  'PAID' = 'PAID',
  'ACCEPTED' = 'ACCEPTED',
  'FAILED' = 'FAILED',
  'FINISHED' = 'FINISHED',
}
